import cx from 'classnames';
import type { FC } from 'react';

import Icon from 'components/Icon/Icon';
import PixDepositForm from 'components/PaymentForm/PixPayments/PixDepositForm';
import type { PaymentPopupDataType } from 'config/types';
import useLayout, { LayoutType } from 'utils/layout';

import type { PopupProps } from '../types';

import styles from './PaymentPopup.module.scss';

const DepositPopup: FC<PopupProps<PaymentPopupDataType>> = ({
  data,
  closePopup,
}) => {
  const layout = useLayout();
  const isMobile = layout === LayoutType.mobile;

  return (
    <div className={cx(styles.wrapper, { [styles.mobile]: isMobile })}>
      <button
        type="button"
        className={styles['close-button']}
        onClick={closePopup}
        data-testid="close"
      >
        <Icon name="close.outline" width={24} height={24} />
      </button>

      {data && <PixDepositForm data={data} />}
    </div>
  );
};

export default DepositPopup;
